import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import moment from 'moment';

import { LANG } from '../util-app-config';

@Pipe({
  name: 'timeStampUpdated',
  standalone: true,
})
export class TimeStampUpdatedPipe implements PipeTransform {
  private translocoService = inject(TranslocoService);

  transform(timestamp: string): string {
    if (timestamp == null) return '';
    const isValid = moment(timestamp).isValid();
    if (!isValid) {
      return this.translocoService.translate('ValueMissing');
    }
    const language = localStorage.getItem(LANG);
    moment.locale(language ? language : 'de');

    const updatedAt = moment.utc(timestamp).local().fromNow();

    return `${updatedAt}`;
  }
}
